import { usePage } from '@inertiajs/react';

import type { SeoMeta } from '@/Types/seo';

type SharedProps = {
    meta: SeoMeta;
};

/**
 * Emits every JSON-LD block the controller pushed onto SeoState. Each block
 * goes in its own `<script type="application/ld+json">` so Google's Rich
 * Results Test parses them independently — one bad block won't sink the
 * page's eligibility for the others.
 */
export function JsonLdScript() {
    const { meta } = usePage<SharedProps>().props;
    const blocks = meta?.jsonLd ?? [];

    return (
        <>
            {blocks.map((block, idx) => (
                <script
                    // eslint-disable-next-line react/no-array-index-key
                    key={`jsonld-${idx}`}
                    type="application/ld+json"
                    // SSR-safe: the controller-controlled JSON is escaped via
                    // JSON.stringify; we further escape `<` and `>` so the
                    // payload can't break out of the <script> tag.
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(block).replace(/</g, '\\u003c').replace(/>/g, '\\u003e'),
                    }}
                />
            ))}
        </>
    );
}
